import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";
import { SURVEY_COLORS } from "../../shared/theme-constants";

// TODO: Review this post upgrading to tailwind to refactor,  to use tailwind classes instead of custom styles
interface IntroStepStylesProps {
  isMobile: boolean;
}

export const useIntroStepStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: (props: IntroStepStylesProps) => (props.isMobile ? "16px" : "24px"),
    maxHeight: (props: IntroStepStylesProps) => (props.isMobile ? "auto" : "calc(50vh - 88px)"),
    [theme.breakpoints.down("sm")]: {
      maxHeight: "none",
      overflowY: "visible",
    },
  },
  contentCard: {
    backgroundColor: SURVEY_COLORS.BACKGROUND_WHITE,
    borderRadius: "8px",
    padding: "24px",
    marginBottom: 0,
    boxShadow: SURVEY_COLORS.BOX_SHADOW,
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: 600,
    marginBottom: "20px",
  },
  sectionQuestion: {
    fontSize: "14px",
    fontWeight: 500,
    marginBottom: "12px",
  },
  notesContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginBottom: "16px",
  },
  highlightNote: {
    borderRadius: "6px",
    padding: "10px 12px",
    fontSize: "13px",
    lineHeight: 1.4,
    fontWeight: 600,
  },
  blueNote: {
    backgroundColor: "#EAF4FF",
    color: "#103A66",
    borderLeft: "4px solid #2D6EA6",
  },
  orangeNote: {
    backgroundColor: "#FFE9D2",
    color: "#5C2E00",
    borderLeft: "4px solid #8B4500",
  },
  buttonContainer: {
    display: "flex",
    gap: "12px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  actionButtonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "16px",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "stretch",
    },
  },
  descriptionText: {
    textAlign: "center",
    fontSize: "16px",
    color: theme.palette.text.secondary,
    marginBottom: "16px",
  },
  primaryButton: {
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: 600,
    height: "40px",
    padding: "12px 16px",
    backgroundColor: SURVEY_COLORS.BUTTON_PRIMARY,
    color: SURVEY_COLORS.MODAL_TEXT_WHITE,
    border: "none",
    textTransform: "none",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    "& .MuiButton-endIcon": {
      marginLeft: "4px",
      "& svg": {
        fontSize: "12px !important",
      },
    },
    "&:hover": {
      backgroundColor: SURVEY_COLORS.BUTTON_PRIMARY,
      outline: `2px solid ${SURVEY_COLORS.BLACK}`,
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${SURVEY_COLORS.BLACK}`,
      fontWeight: 700,
      "& .MuiTouchRipple-child": {
        backgroundColor: "transparent",
      },
    },
    "&:disabled": {
      opacity: 0.5,
      backgroundColor: SURVEY_COLORS.BUTTON_PRIMARY,
      color: SURVEY_COLORS.MODAL_TEXT_WHITE,
    },
  },
  outlineButton: {
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: 600,
    height: "40px",
    padding: "12px 16px",
    backgroundColor: "transparent",
    color: SURVEY_COLORS.TEXT_PRIMARY,
    border: `1px solid ${theme.palette.divider}`,
    textTransform: "none",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    "&:hover": {
      backgroundColor: SURVEY_COLORS.BUTTON_HOVER_BG,
      outline: `2px solid ${SURVEY_COLORS.BLACK}`,
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${SURVEY_COLORS.BLACK}`,
      fontWeight: 700,
      "& .MuiTouchRipple-child": {
        backgroundColor: "transparent",
      },
    },
  },
}));
